import axios from 'axios';
import {
  FETCH_HISTORY_SUCCESS,
  FETCH_HISTORY_FAIL,
  FETCH_SUB_HISTORY_SUCCESS,
  FETCH_SUB_HISTORY_FAIL,
  FETCH_ORDER_HISTORY_SUCCESS,
  FETCH_ORDER_HISTORY_FAIL,
  EXPORT_HISTORY_SUCCESS,
  EXPORT_HISTORY_FAIL,
  GENERATE_STATEMENT_SUCCESS,
  GENERATE_STATEMENT_FAIL,
} from './types';

export const fetchHistory = (params, type) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/history/' + type;
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_HISTORY_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_HISTORY_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_HISTORY_FAIL });
  }
};

export const fetchSubHistory = (params, type) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/history/' + type;
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_SUB_HISTORY_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_SUB_HISTORY_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_SUB_HISTORY_FAIL });
  }
};

export const fetchOrderHistory = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/orders';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_ORDER_HISTORY_SUCCESS, payload: response.data, typeHandle: params.type });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_ORDER_HISTORY_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_ORDER_HISTORY_FAIL });
  }
};

export const exportHistory = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/history';
  try {
    const response = await axios.post(url, null, { params });
    return dispatch({ type: EXPORT_HISTORY_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: EXPORT_HISTORY_FAIL, errors: error });
    }

    return dispatch({ type: EXPORT_HISTORY_FAIL });
  }
};

export const requestGenerateStatement = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/invoices';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: GENERATE_STATEMENT_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: GENERATE_STATEMENT_FAIL, errors: error.response.data });
    }

    return dispatch({ type: GENERATE_STATEMENT_FAIL });
  }
}
